/**
 * "now" / "5 min ago" / "2 hours ago" / "3 days ago", falling back to a
 * plain calendar date once something is old enough that a relative label
 * stops being useful. Requested for Home's Recent Sessions/Projects/
 * Favorites lists, where everything created in one working session showed
 * the exact same unhelpful "9/19/2026" for every single row.
 */
export function formatRelativeTime(value) {
    if (!value) { return ''; }
    const date = value instanceof Date ? value : new Date(value);
    const ms = Date.now() - date.getTime();
    if (!Number.isFinite(ms)) { return ''; }

    // A slightly-in-the-future timestamp (clock skew, or a write that
    // landed a moment after this render started) should still read "now",
    // not a nonsensical negative duration.
    const seconds = Math.round(Math.max(0, ms) / 1000);
    if (seconds < 30) { return 'now'; }

    const minutes = Math.round(seconds / 60);
    if (minutes < 60) { return `${minutes} min ago`; }

    const hours = Math.round(minutes / 60);
    if (hours < 24) { return `${hours} hour${hours === 1 ? '' : 's'} ago`; }

    const days = Math.round(hours / 24);
    if (days < 7) { return `${days} day${days === 1 ? '' : 's'} ago`; }

    return date.toLocaleDateString();
}
